import { render, staticRenderFns } from "./FavoriteIcon.vue?vue&type=template&id=1702db28&scoped=true"
import script from "./FavoriteIcon.vue?vue&type=script&lang=js"
export * from "./FavoriteIcon.vue?vue&type=script&lang=js"
import style0 from "./FavoriteIcon.vue?vue&type=style&index=0&id=1702db28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1702db28",
  null
  
)

export default component.exports